import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private http: HttpClient) { }

  checkUsernameExists(username: string): Observable<boolean> {
    return this.http.get<any>(Library.API_ENDPOINT + `common/check_username/${username}`, OPTIONS)
      .pipe(map(response => response));
  }

  createUpdateConfig(systemForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `common/save_update_config`, systemForm, OPTIONS);
  }

  getConfigs() {
    return this.http.get<any>(Library.API_ENDPOINT + 'common/get_configs', OPTIONS);
  }

  deleteConfig(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `common/delete_config/${id}`, OPTIONS);
  }

  getWebsiteMaintenanceStatus() {
    return this.http.get<any>(Library.API_ENDPOINT + 'common/website_maintenance_status', OPTIONS);
  }

  getInActiveStatus(id: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `common/get_in_active_status/${id}`, OPTIONS);
  }

  getLeaveCredits() {
    return this.http.get<any>(Library.API_ENDPOINT + 'common/get_leave_credits', OPTIONS);
  }

  sendPendingLeaves(email: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `common/send_pending_leaves/${email}`, OPTIONS);
  }

  getSubscriptionInfo(id: any, uuid: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `common/get_subscription_info/${id}/${uuid}`, OPTIONS);
  }

  getMonths() {
    return this.http.get<any>(Library.API_ENDPOINT + `common/get_months`, OPTIONS);
  }

  verifyPassword(pass: any) {
    return this.http.get<any>(Library.API_ENDPOINT + `common/verify_password/${pass}`, OPTIONS);
  }

  getRecordEntries() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_record_entries', OPTIONS);
  }

  createUpdateClient(clientForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `common/save_update_client`, clientForm, OPTIONS);
  }

  getClients() {
    return this.http.get<any>(Library.API_ENDPOINT + 'common/get_clients', OPTIONS);
  }

  deleteClient(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `common/delete_client/${id}`, OPTIONS);
  }

  deleteSPClient(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `common/delete_sp_client/${id}`, OPTIONS);
  }
}
